var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0013 2.66669C6.52797 2.66669 5.33464 3.86002 5.33464 5.33335C5.33464 6.80669 6.52797 8.00002 8.0013 8.00002C9.47464 8.00002 10.668 6.80669 10.668 5.33335C10.668 3.86002 9.47464 2.66669 8.0013 2.66669ZM9.33463 5.33335C9.33463 4.60002 8.73463 4.00002 8.0013 4.00002C7.26797 4.00002 6.66797 4.60002 6.66797 5.33335C6.66797 6.06669 7.26797 6.66669 8.0013 6.66669C8.73463 6.66669 9.33463 6.06669 9.33463 5.33335ZM12.0013 11.3334C11.868 10.86 9.8013 10 8.0013 10C6.2013 10 4.13464 10.86 4.0013 11.34V12L12.0013 12V11.3334ZM2.66797 11.3334C2.66797 9.56002 6.2213 8.66669 8.0013 8.66669C9.7813 8.66669 13.3346 9.56002 13.3346 11.3334V13.3334L2.66797 13.3334L2.66797 11.3334Z",
    fill: "#454A54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.908a0110019cc76696ebe8c835472aed.svg";
export { ForwardRef as ReactComponent };